import {TheCryptGameConfig} from "../TheCryptGameConfig";

export class TheCryptSymbolAnimation extends PIXI.Container{
    constructor() {
        super();
        this.name = "SymbolAnimation";
        this.position=TheCryptGameConfig.reelAreaPos;
    }
}